import PlanValueProp from './PlanValueProp'

export default PlanValueProp
// eslint-disable-next-line import/export
export * from './PlanValueProp'
